import React from 'react';
import { ECMID } from '../../../constants';
import { Grid, TextField,  FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import FormNumberField from '../../../component/NumberInput';


const AddNewRequest = ({fields,changeHandler,handleBlurUpdate}) => {

    return (
        <>
            <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl
                        margin="dense"
                        fullWidth
                    >
                        <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            sx={{
                                "&:focus": {
                                    backgroundColor: "#ffffff"
                                }
                            }}
                            label="ECMID"
                            value={fields.ECMID}
                            onChange={changeHandler}
                            name="ECMID"
                            error={fields.ECMID === ""}
                        >
                            <MenuItem value="">Select ECMID</MenuItem>
                            {ECMID?.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" ? "Required Field!" : false}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormNumberField
                        className='fieldFullWidth numberInputField'
                        margin="dense"
                        id="DestAddrOverd"
                        label="DestAddrOverd"
                        name="DestAddrOverd"
                        value={fields.DestAddrOverd}
                        onBlurUpdate={handleBlurUpdate}
                        error={true}
                        helperText={true}
                        type="int"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormNumberField
                        className='fieldFullWidth numberInputField'
                        margin="dense"
                        id="PGN"
                        label="PGN"
                        name="PGN"
                        value={fields.PGN}
                        onBlurUpdate={handleBlurUpdate}
                        error={true}
                        helperText={true}
                        type="int"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormNumberField
                        className='fieldFullWidth numberInputField'
                        margin="dense"
                        id="TrigAddr"
                        label="TrigAddr"
                        name="TrigAddr"
                        value={fields.TrigAddr}
                        onBlurUpdate={handleBlurUpdate}
                        error={true}
                        helperText={true}
                        type="int"
                    />
                </Grid>
            </Grid>
            <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormNumberField
                        className='fieldFullWidth'
                        margin="dense"
                        id="ReTxRate"
                        label="ReTxRate"
                        name="ReTxRate"
                        value={fields.ReTxRate}
                        onBlurUpdate={handleBlurUpdate}
                        error={true}
                        helperText={true}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={9}>
                    <TextField
                        fullWidth
                        margin="dense"
                        id="Desc"
                        label="Desc"
                        name="Desc"
                        value={fields.Desc}
                        multiline
                        rows={1}
                        onChange={changeHandler}
                        error={fields.Desc === ""}
                        helperText={fields.Desc === "" ? "Required Field!" : false}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default AddNewRequest;
